import { useCallback, useRef } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { userInformationAtom } from '../Services/_states';
import {
  areUserSessionsEqual,
  fetchFreshUserSession,
  persistUserSession,
} from '../authorization/userSession';

/**
 * Refreshes userInfo + localStorage from v0/user/{id}/ (live rbac_grants).
 */
export default function useRefreshUserSession() {
  const userInfo = useRecoilValue(userInformationAtom);
  const setUserInfo = useSetRecoilState(userInformationAtom);
  const userInfoRef = useRef(userInfo);
  userInfoRef.current = userInfo;

  const refreshUserSession = useCallback(async (userId) => {
    const userData = await fetchFreshUserSession(userId);
    if (!userData || areUserSessionsEqual(userInfoRef.current, userData)) {
      return userData;
    }

    // Update only when session data genuinely changed. Preserving the same
    // Recoil object prevents app-wide route/layout rerenders and UI flicker.
    userInfoRef.current = userData;
    persistUserSession(userData);
    setUserInfo(userData);
    return userData;
  }, [setUserInfo]);

  return refreshUserSession;
}
